<mbs-modal [title]="'wizards:networkShareCredentials' | i18next: { format: 'title' }">
  <ng-container modal-body
                [formGroup]="form">
    <span class="d-block mb-3">
      Selected path: {{root?.path}}
    </span>

    <mbs-form-group>
      <mbs-input formControlName="login"
                 name="login"
                 [id]="'login-input'"
                 [label]="'wizards:addNetworkShareLogin' | i18next"
                 [placeholder]="'wizards:addNetworkShareLoginPlaceholder' | i18next"
                 [validationWhitespace]="true"></mbs-input>
    </mbs-form-group>

    <mbs-input-password formControlName="password"
                        name="password"
                        [label]="'wizards:addNetworkSharePass' | i18next"
                        [placeholder]="'wizards:addNetworkSharePassPlaceholder' | i18next"
                        [id]="'add-network-share-password-input'"></mbs-input-password>
  </ng-container>

  <ng-container modalFooter>
    <button type="button"
            class="btn btn-primary"
            (click)="saveCredentials()">{{ 'shared:buttons.save' | i18next: { format: 'title' } }}</button>
    <button type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            (click)="cancelClickHandler()">{{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}</button>
  </ng-container>
</mbs-modal>
